export default function (tns) {
  const sliders = Array.from(
    document.querySelectorAll('.PostsGroup__list .tns-gallery')
  )

  sliders.forEach((slider) => applyTinySlideConfigs(slider, tns))
}

function applyTinySlideConfigs(slider, tns) {
  return tns({
    container: slider,
    gutter: 0,
    nav: false,
    autoHeight: true,
    items: 1,
    edgePadding: 0,
    loop: false,
    preventScrollOnTouch: 'force',
  })
}
